import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import useVersion from '../../utils/hooks/useVersion';

const Pixel = ({ cotizar, resumen, modelo, tipo }) => {
  // This version number is to make pixel to reload the script
  const [version] = useState(Math.floor(Math.random() * 10000));
  const carVersion = useVersion();
  const params = useParams();

  const requiresVersion = useCallback(() => {
    return cotizar || resumen;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Delete this check once marketing team decides to fully use the pixel
  const onlyIncludeModel = "COOLRAY";

  const changeMathPath = useCallback(() => {
    const {
      tipo: tipoParam,
      modelo: modeloParam,
      color,
    } = params;

    // Default MathTag
    const mathTag = {
      version: "1.1",
      previous_url: document.referrer,
      industry: "Autos",
      mt_adid: "253388",
      event_type: "catchall",
      mt_id: "1585689",
    };

    if (tipo) {
      mathTag.mt_id = "1585688";
      mathTag.product_category = tipoParam;
    }

    if (modelo && modeloParam === onlyIncludeModel) {
        mathTag.product_category = tipoParam;
        mathTag.product_brand = modeloParam;
        mathTag.event_type = "product_detail";
        mathTag.mt_id = "1585687"
    }

    if (resumen && modeloParam === onlyIncludeModel) {
      mathTag.product_category = tipoParam;
      mathTag.product_brand = modeloParam;
      mathTag.product_id = carVersion?.version?.codigoAnio;
      mathTag.product_price = carVersion?.version?.precioOferta;
      mathTag.v3 = color;
      mathTag.event_type = "conversion";
      mathTag.mt_id = "1585686"
    }

    if (cotizar && modeloParam === onlyIncludeModel) {
      mathTag.product_category = tipoParam;
      mathTag.product_brand = modeloParam;
      mathTag.product_id = carVersion?.version?.codigoAnio;
      mathTag.product_price = carVersion?.version?.precioOferta;
      mathTag.v3 = color;
      mathTag.event_type = "complete_form";
      mathTag.mt_id = "1585690"
    }

    window.MathTag = mathTag;
    // setVersion(Math.floor(Math.random() * 10000));
  }, [carVersion.version.codigoAnio, carVersion.version.precioOferta, cotizar, modelo, params, resumen, tipo]);

  const canRender = useCallback(() => {
    if (requiresVersion() && Object.keys(carVersion?.version)?.length === 0) {
      return false;
     } 
     return true;
  }, [carVersion.version, requiresVersion]);
  
  useEffect(() => {
   if (!canRender()) {
    return;
   }

   changeMathPath();
  }, [canRender, changeMathPath]);

  return (
    <Helmet>
      {canRender() && <script async type="text/javascript" src={`//pixel.mathtag.com/event/js?mt_pp=1&mt_adid=253388&ve=${version}`}></script>}
    </Helmet>
  );
};

export default Pixel;